var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('my-page-content-template',{attrs:{"title":"お支払い詳細","subtitle":"Payment Details"}},[_c('payment-detail',{attrs:{"payment-id":_vm.id}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }